import '~/js/modules/stickyNav';
import 'slick-carousel';
import CanvasDownload from '~/js/modules/canvasDownload';

// test mobile devices
const mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent);

// ===== Create href for back link =====
class BackLink {
  constructor(backLink) {
    this.backLink = document.querySelector(`#${backLink}`);

    // this.returnUrl();
  }

  returnUrl = () => {
    const url = window.location.href;
    const newUrl = url.slice(0, url.indexOf('details'));

    this.backLink.href = newUrl;
  }
}

const topBackLink = new BackLink('back-link--top');
const bottomBackLink = new BackLink('back-link--bottom');

topBackLink.returnUrl();
bottomBackLink.returnUrl();

// ===== Slider =====
class Slider {
  constructor() {
    //  After init slider
    $('#slider').on('init', this.changeCounter);
    // Initialization slider
    this.slider = $('#slider').slick({
      prevArrow: $('.info__slider-btn--prev'),
      nextArrow: $('.info__slider-btn--next'),
      dots: (mobile ? true : false),
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            dots: true
          }
        }
      ]
    });
  }

  //  After change slide
  startSlider = () => {
    this.slider.on('afterChange', this.changeCounter);
  }

  // change count after change slide
  changeCounter(event, slick, currentSlide) {
    const count = document.querySelector('.count');
    const countSlides = document.querySelector('.count-slides');

    count.innerHTML = (currentSlide + 1) || 1;
    countSlides.innerHTML = slick.slideCount;
  }
}

const restaurantSlider = new Slider;

restaurantSlider.startSlider();


// ===== Tabs =====
class Tabs {
  constructor() {
    this.tabs = document.querySelectorAll('.info__tab');
    this.btns = document.querySelector('.info__tabs-btns-wrap');
  }

  _hidden = () => {
    for(const tab of this.tabs) {
      tab.setAttribute('hidden', 'hidden');
    }
    for(const btn of this.btns.children) {
      btn.classList.remove('info__tabs-btn--active');
    }
  }

  _events = () => {
    this.btns.addEventListener('click', ev => {
      if(ev.target.hasAttribute('disabled')) {
        return;
      }

      this._hidden();
      for(let i = 0; i < this.btns.children.length; i++) {
        if(ev.target === this.btns.children[i]) {
          this.tabs[i].removeAttribute('hidden');
          this.btns.children[i].classList.add('info__tabs-btn--active');
          $('#slider').slick('setPosition');
        }
      }
    });
  }

  startEvents = () => {
    this._events();
  }
}

const restaurantTabs = new Tabs;

restaurantTabs.startEvents();

// ===== Popover =====
class Popover {
  constructor(popoverBtnElem, popoverElem) {
    this.popover = document.querySelector(`${popoverElem}`);
    this.popoverBtn = document.querySelector(`${popoverBtnElem}`);
    this.btnClose = document.querySelector(`${popoverElem} .icon-close`);

    this._events();
  }

  // hidden popover
  _hiddenPopover = () => {
    this.popover.setAttribute('hidden', 'hidden');
  }

  // show popover
  _showPopover = () => {
    this.popover.removeAttribute('hidden');
  }

  // event click in window
  _clickWindow = ev => {
    let evTarget = ev.target;

    while(evTarget !== this.popover && evTarget !== document.body && evTarget !== this.popoverBtn) {
      evTarget = evTarget.parentNode;

      if(evTarget.classList.contains('restaurant-details')) {
        this._hiddenPopover();
        break;
      }
    }
  }

  // events
  _events = () => {
    this.btnClose.addEventListener('click', () => {
      this._hiddenPopover();
    });

    document.querySelector('.restaurant-details').addEventListener('click', e => this._clickWindow(e));

    this.popoverBtn.addEventListener('click', e => {
      e.preventDefault();
      if(this.popover.hasAttribute('hidden')) {
        this._showPopover();
      } else {
        this._hiddenPopover();
      }
    });
  }
}

document.querySelector('#popover-btn') && new Popover('#popover-btn', '#popover');

// ===== Download image =====

// For mobile
if(mobile) {
  document.querySelector('.info__slider-controls').style.display = 'none';
} else {
  const downloadImg = document.querySelector('.slick-active img');
  const imgObject = new CanvasDownload('.slick-active img', '.js-download');

  downloadImg.classList.add('download-img');
  imgObject.createCanvas();
  imgObject.createWaterMark();


  const watermark = document.querySelector('#watermark');

  watermark.addEventListener('load', () => imgObject.convertImageToCanvas('.slick-active img'));

  $('#slider').on('afterChange', () => imgObject.convertImageToCanvas());
}
